module.exports = __webpack_public_path__ + "img/img24.2b9d9f7d.svg";